@if (loading) {
  <lib-skeleton-card-table></lib-skeleton-card-table>
} @else {
  @for (freight of freights$ | async; track freight.id) {
    <lib-freight-shipper-card [freight]="freight"></lib-freight-shipper-card>
  } @empty {
    <p class="ion-text-center ion-padding">{{ 'freight.general.without_freights' | translate }}</p>
  }
}
